import { render, staticRenderFns } from "./CompareViewItem.vue?vue&type=template&id=4f641ff4&scoped=true&"
import script from "./CompareViewItem.vue?vue&type=script&lang=js&"
export * from "./CompareViewItem.vue?vue&type=script&lang=js&"
import style0 from "./CompareViewItem.vue?vue&type=style&index=0&id=4f641ff4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f641ff4",
  null
  
)

export default component.exports